<template>
    <ul class="layout-submenu" style="display: none">
        <template v-for="(route, index) in menuData">
            <template v-if="route.children">
                <template v-if="route.children.length">
                    <li
                        :key="index"
                        class="layout-submenu-item"
                        @mouseover="$navigationOver"
                        @mouseleave="$navigationLeave"
                    >
                        <div class="layout-submenu-title">
                            <router-link :to="route.path">
                                <span>{{ route.name }}</span>
                            </router-link>
                        </div>
                        <v-menu :menuData="route.children" />
                    </li>
                </template>
                <template v-else>
                    <li :key="index" class="layout-submenu-item">
                        <router-link
                            :to="route.path"
                            :class="route.path == $route.path ? 'layout-submenu-selected' : ''"
                        >
                            <span>{{ route.name }}</span>
                        </router-link>
                    </li>
                </template>
            </template>
        </template>
    </ul>
</template>

<script>
export default {
    name: 'v-menu',
    props: ['menuData'],
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {}
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
.layout {
    &-submenu {
        width: 120px;
        margin-left: 4px;
        padding: 4px 0;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background-color: #001529;
        position: absolute;
        top: 0;
        left: 100%;
        z-index: 9;
        -webkit-animation-timing-function: ease-in;
        animation-timing-function: ease-in;
        -webkit-animation-duration: 0.04s;
        animation-duration: 0.04s;
        &-active {
            display: block;
        }
        &-item {
            margin-right: -4px;
            border-right: 4px solid transparent;
            &:hover {
                > .layout-submenu {
                    display: block;
                }
            }
            a {
                display: flex;
                align-items: center;
                padding: 0 16px;
                color: #a8adb4;
                font-weight: bold;
                line-height: 40px;
                &:hover,
                &.router-link-active {
                    color: #fff;
                }
            }
            span {
                flex: 1;
            }
        }
        &-selected {
            background-color: @color-primary;
            color: #fff;
        }
        &-title {
            cursor: pointer;
            &:hover {
                color: #fff;
            }
        }
    }
}
</style>
